import React, { useState } from "react";
import axios from "axios";
import DOMPurify from "dompurify";
import "./forgetpassword.css";
function ResetPassword() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const url = `${process.env.REACT_APP_API}/secure/reset`;
    const resetToken = window.location.href.split("/")[5];
    const data = {
      password: DOMPurify.sanitize(password, {
        ALLOWED_ATTR: [],
        ALLOWED_TAGS: [],
      }),
      resetToken,
    };
    axios
      .patch(url, data)
      .then((res) => {
        console.log(res.data.message);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
        setError(error.message);
      });
  };

  return (
    <div className="content-container">
      <div className="forgot-password-container">
        <form className="forgot-password-form" onSubmit={handleSubmit}>
          <h2 className="header-reset">Reset password</h2>
          <input
            type="password"
            placeholder="Password"
            className="user-email"
            name="cpassword"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          {error && (
            <div className="error-message" style={{ color: "red" }}>
              {error}
            </div>
          )}
          <button type="submit" className="password-button" disabled={loading}>
            {loading ? "Loading..." : "Reset Password"}
          </button>
        </form>
        {loading && <div className="loader">Loading...</div>}
      </div>
    </div>
  );
}

export default ResetPassword;
